import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import {
  MerchantActions,
  MerchantSelectors,
} from '@merchant/store/merchant.slice';
import { ProductsService } from '@products/services/products.service';
import { DialogService } from '@shared/services/dialog.service';

@Component({
  selector: 'app-products-container',
  templateUrl: './products-container.component.html',
  styleUrls: ['./products-container.component.scss'],
})
export class ProductsContainerComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  public showRejectedTab: boolean = true;

  merchantType = '';

  requiredMerchantDataFilled$ = this.store.select(
    MerchantSelectors.selectRequiredMerchantDataFilled
  );

  constructor(
    private productService: ProductsService,
    private store: Store,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.store
        .select(MerchantSelectors.selectMerchantType)
        .subscribe((merchantType) => {
          this.merchantType = merchantType ?? '';
        })
    );
  }

  add() {
    if (
      [
        'RETAILER_AS_HOTEL',
        'RETAILER_AS_RESTAURANT',
        'RETAILER_AS_CAFE',
        'RETAILER_AS_RETAIL_CHAIN',
        'RETAILER_AS_TRAFIK',
        'RETAILER_AS_OTHER_RETAILER',
      ].includes(this.merchantType)
    ) {
      this.dialogService.open({
        type: 'NOTICE',
        title: 'PRODUCTS.OTHER_USER_TYPE_NOTICE.TITLE',
        content: 'PRODUCTS.OTHER_USER_TYPE_NOTICE.CONTENT',
      });
      this.router.navigate(
        ['/selling/sortiment/product-sortiment/products-start/products/edit'],
        {
          queryParams: { userType: 'OTHER' },
          relativeTo: this.route,
        }
      );
    } else {
      this.subs.sink = this.productService.addProduct().subscribe();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
